import { render, staticRenderFns } from "./buypileh5.vue?vue&type=template&id=55de994e&scoped=true&"
import script from "./buypileh5.vue?vue&type=script&lang=js&"
export * from "./buypileh5.vue?vue&type=script&lang=js&"
import style0 from "./buypileh5.vue?vue&type=style&index=0&id=55de994e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55de994e",
  null
  
)

export default component.exports